module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_4.275f008f.jpg";